// extracted by mini-css-extract-plugin
module.exports = {"cardsDivv":"CardsData_cardsDivv__BWwq4","cardsDivInnerd":"CardsData_cardsDivInnerd__1qxQX","cardsMainDd":"CardsData_cardsMainDd__RbSr6"};